import React from 'react';
import classnames from 'classnames';

import MenuChoiceOptions from '../MenuChoiceOptions';
import MenuChoiceAttributeTitle from '../MenuChoiceAttributeTitle';

import { ViewerAttributeInterface, ViewerItemInterface, ViewerOptionInterface, ViewerOptionInterfaceInput } from '../../core';

import styled from './MenuChoiceAttributes.module.scss';
import { useCustomizationParams, useViewerState } from '../../context/ViewerContext';
import useSelectionHook from '../../hooks/use-selection';
import { hideAttributeIfHasOneOption } from '../../core/utils/functions';
import MenuChoiceOptionsInput from '../MenuChoiceOptionsInput';

export interface MenuChoiceAttributesProps {
  hasParent?: boolean;
  isActive?: boolean;
  attributes: ViewerAttributeInterface[];
  bulkDataAttributes: ViewerAttributeInterface[] | undefined;
  setBulkDataOptionValue: (option: ViewerOptionInterfaceInput, value: string) => void;
  showOptionPreview: (option: ViewerOptionInterface) => void;
  optionSelect: (option: ViewerItemInterface) => void;
}

const MenuChoiceAttributes: React.FC<MenuChoiceAttributesProps> = (props) => {
  const { onSelectAttribute, onSelectOptions } = useSelectionHook();
  const { customizationParams } = useCustomizationParams();
  const { viewerState } = useViewerState();

  const hideAttrParam = customizationParams?.hideSingleOptionAttributes;

  const selectOption = (item: ViewerItemInterface) => {
    onSelectOptions(item);
    props.optionSelect(item);
  };

  return (
    <div
      className={classnames(styled.ff_menu_choice_attributes, {
        [styled.ff_menu_choice_attributes__parent]: props.hasParent,
        [styled.ff_menu_choice_attributes__active]: props.isActive,
      })}
      data-testid='ff-menu-choice-attributes'
    >
      {props.attributes.map(
        (attr) =>
          !hideAttributeIfHasOneOption(attr, hideAttrParam) && (
            <div key={`${attr.id}-${attr.name}`} className={classnames(styled.ff_menu_choice_attribute)}>
              <MenuChoiceAttributeTitle isActive={attr.id === viewerState.attributeId} attribute={attr} select={onSelectAttribute} />
              {attr.options && !attr.isInput && (
                <MenuChoiceOptions
                  onSelectOptions={selectOption}
                  isOpen={viewerState.openedAttributes.includes(attr.id)}
                  options={attr.options}
                  showOptionPreview={props.showOptionPreview}
                  optionSelect={props.optionSelect}
                />
              )}

              {attr.options && attr.isInput && (
                <MenuChoiceOptionsInput
                  onSelectOptions={selectOption}
                  isOpen={viewerState.openedAttributes.includes(attr.id)}
                  options={attr.options}
                  showOptionPreview={props.showOptionPreview}
                  optionSelect={props.optionSelect}
                  bulkDataOptions={props.bulkDataAttributes?.find((a) => a.id === attr.id)?.options}
                  setBulkDataOptionValue={props.setBulkDataOptionValue}
                />
              )}
            </div>
          )
      )}
    </div>
  );
};

export default MenuChoiceAttributes;
